import { useQuery } from "@tanstack/react-query";
import { useApi } from "@csa/web-foundation";
import type { AdvisorDay } from "./types";

/** The scopes a caller may ASK for. Undefined = whatever the grant resolves to. */
export type AdvisorDayScope = "own" | "team" | "all";

/**
 * GET /v1/metrics/advisor-day — the ONE composed Günüm rollup (capacity, SLA
 * health, renewal pipeline, conversion, portfolio depth, trust strip).
 *
 * A4: the read now accepts an OPTIONAL `?scope=`, which can only NARROW within
 * the caller's grant (the server 403s anything wider — it does not silently
 * clamp). Passing nothing keeps the previous behaviour exactly: the server
 * resolves the widest granted scope. That default matters, because an advisor
 * holding only `own` must never be asked to pick.
 *
 * `scope` is part of the queryKey so switching refetches instead of showing a
 * stale book under a new label — the one bug that would make the toggle worse
 * than the dead chip it replaces.
 */
export function useAdvisorDay(scope?: AdvisorDayScope) {
  const api = useApi();
  return useQuery({
    queryKey: ["advisor-day", scope ?? "granted"],
    retry: false,
    queryFn: () => api.get<AdvisorDay>(`/v1/metrics/advisor-day${scope ? `?scope=${scope}` : ""}`),
  });
}
